// extracted by mini-css-extract-plugin
export default {"modalOverlay":"VE-z","modalContent":"WE-z","header":"XE-z","close":"YE-z"};